import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6d006e5a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d006e5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d006e5a')) {
      api.createRecord('6d006e5a', component.options)
    } else {
      api.reload('6d006e5a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6d006e5a&scoped=true&", function () {
      api.rerender('6d006e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormItem/TSlider/index.vue"
export default component.exports